import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { Breakpoint, Color, FontWeight, TabSmallTheme } from '../../../enums';
import { StyledComponent } from '../../../interfaces';

import { ColorCircleProps, ContainerProps, LabelProps } from './tabSmall.types';

const TabSmallThemeStyles: { [t in TabSmallTheme]: FlattenSimpleInterpolation } = {
  [TabSmallTheme.Orange]: css`
    background-color: ${Color.Error500};
    border-radius: 50px;
  `,
  [TabSmallTheme.White]: css`
    background-color: ${Color.White};
    border-radius: 50px;
  `,
  [TabSmallTheme.Transparent]: css`
    border: 1px solid ${Color.Gray300};
    background-color: ${Color.Transparent};
    border-radius: 50px;

    &:hover {
      background-color: ${Color.Gray200};

      @media ${Breakpoint.Mobile} {
        background-color: ${Color.Transparent};
      }
    }
  `,
  [TabSmallTheme.Gray]: css`
    border: 1px solid ${Color.Gray300};
    background-color: ${Color.Gray200};
    border-radius: 50px;
  `,
  [TabSmallTheme.WithOutline]: css`
    border: 1px solid ${Color.Black};
    border-radius: none;
  `,
};

export const Container: StyledComponent<'button', ContainerProps> = styled.button.attrs<ContainerProps>({ type: 'button' })`
  width: fit-content;
  height: fit-content;
  padding: 12px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ $theme }: ContainerProps): FlattenSimpleInterpolation => TabSmallThemeStyles[$theme]};
`;

export const LabelAndColorContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Label: StyledComponent<'p', LabelProps> = styled.p<LabelProps>`
  color: ${({ $theme }: LabelProps): string => $theme === TabSmallTheme.Orange ? Color.White : Color.Black};
  font-size: 14px;
  line-height: 18px;
  font-weight: ${({ $theme }: LabelProps): string => $theme === TabSmallTheme.WithOutline ? FontWeight.Medium : FontWeight.Regular};
`;

export const ColorCircle: StyledComponent<'div', ColorCircleProps> = styled.div<ColorCircleProps>`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${({ $color }: ColorCircleProps): string => $color};
  border: ${({ $color }: ColorCircleProps): string => $color === Color.White ? `1px solid ${Color.Gray300}` : 'none'};
  margin-right: 8px;
  flex-shrink: 0;
`;
